export { DefaultSingleUserStateProvider } from "@bitwarden/state";
